export default "__VITE_PUBLIC_ASSET__598eebf6__"